export const HOME_ROUTE = '/home';
export const SUPERADMIN_PATH = '/admin/superadmin';
export const LOGIN_ROUTE = '/login';
export const SSO_LOGIN_ROUTE = '/sso';
export const FEATUREBASE_SSO_ROUTE = '/sso/featurebase';
export const AUTH_EXPIRED_QUERY_PARAM = 'authExpired';
export const LOGIN_ROUTE_AUTH_EXPIRED = `${LOGIN_ROUTE}?${AUTH_EXPIRED_QUERY_PARAM}=true`;
export const SSO_LOGIN_ROUTE_AUTH_EXPIRED = `${SSO_LOGIN_ROUTE}?${AUTH_EXPIRED_QUERY_PARAM}=true`;
export const SIGNUP_ROUTE = '/signup';
export const ERROR_NOT_FOUND_ROUTE = '/error/404';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const CLIENT_DETAIL_ROUTE = '/detail';
export const UNUPLOADED_SESSIONS_ROUTE = '/unuploaded-sessions';
export const ZOOM_APP_HOME_ROUTE = '/zoom-app/home';
export const TRAINING_ROUTE = '/training';
